import { useContext } from "react";
import { WishlistContext } from "./components/WishlistProvider/context";
import { hookFactory } from "./useHook";
export var useCheckout = hookFactory("checkout");
export var useCart = hookFactory("cart");
export function useWishlist() {
  return useContext(WishlistContext);
}